

<div class="row">
    <div class="col-md-5">
        <div class="input-group">
            <input type="text" name="feedback_search" id="search" [formControl]="searchInputCtrl"
                class="form-control" 
                placeholder="{{ 'taskbook.backlog.search' | translate}}">
            <span class="input-group-text icon-addon"> 
                @if(search_terms){
                    <i class="far fa-times" (click)="clear_search()"></i>
                }
                @else {
                    <i class="far fa-search"></i>
                }
            </span>
        </div>
    </div>
</div>

<div class="py-2 d-md-flex">
    <div class="filter-menu">
        @for(label of labelSelectionForSearch; track label){
            @let labelCount = getLabelCount(label.id);
            @if(labelCount > 0){
                <div class="d-inline-block">
                    <button class="filter-btn mt-1 me-1" 
                            [ngClass]="{ active: label.selected }" 
                            (click)="toggleLabel(label.id)" >
                        <i class="fa-circle pe-1" 
                           [ngClass]="label.id === 'all' ? 'd-none' : label.selected ? 'fa-solid' : 'fa-regular' "
                           [ngStyle]="{'color': label.color}"></i>{{label.name}} ({{labelCount}})
                    </button>
                </div>
            }
        }
    </div>
    <div class="sort-menu mt-2 mt-md-0">
        <button class="btn btn-secondary filter-btn mt-1" [matMenuTriggerFor]="menu">
            <i class="fa-light fa-sort pe-1"></i>{{'taskbook.backlog.sort' | translate}}
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="sortBy('published-date-desc')">{{'taskbook.backlog.sort.date_desc' | translate}}</button>
            <button mat-menu-item (click)="sortBy('published-date-asc')">{{'taskbook.backlog.sort.date_asc' | translate}}</button>
            <button mat-menu-item (click)="sortBy('update-date-desc')">{{'taskbook.backlog.sort.update_desc' | translate}}</button>
            <button mat-menu-item (click)="sortBy('update-date-asc')">{{'taskbook.backlog.sort.update_asc' | translate}}</button>
        </mat-menu>
      </div>
</div>

<div class="py-2 row">
    <div class="checkbox ms-2 col-auto d-flex align-items-center">
        <label class="d-flex align-items-center pe-4">
            <input type="checkbox" title="Select all" class="ps-2 pe-1"
                (click)="select_all()" 
                [(ngModel)]="select_all_state">&nbsp;&nbsp;{{'select_all' | translate}} 
        </label>
        <multi-task-assignee-selector [selectedAssignees]="assigneeSelection"
                            [managers]="managers"
                            [selectedItems]="taskSelection"
                            [context]="'backlogList'"
                            (assigneesChange)="onApplyAssigneeSelection($event)"></multi-task-assignee-selector>

        <multi-task-label-popover-selector [selectedLabels]="labelSelection"
                                            [selectedItems]="taskSelection"
                                            [context]="'backlogList'"
                                            (labelsChange)="onApplyLabelSelection($event)"></multi-task-label-popover-selector>
    </div>
</div>

<div class="backlog-list">
    <div class="titles">
        <div class="checkbox"></div>
        <div class="content">{{ 'taskbook.backlog.list_feedback' | translate }}</div>
        <div></div>
        <!-- <div class="assignees">{{ 'taskbook.backlog.list_assignees' | translate }}</div> -->
        <div class="last-update">{{ 'taskbook.backlog.list_last_update' | translate }}</div>
    </div>
    @if(filteredListItems.length > 0){
        @for(item of filteredListItems; track item.task.id; let i = $index){
            <div class="line" [ngClass]="item.isRead(userId) ? 'read-task' : 'fw-bold'">
                <div class="d-flex content">
                    <div class="checkbox pe-3" [ngClass]="{'pt-4' : displayTeamNames}">
                        <label class="pt-2">
                            <input type="checkbox" [ngModel]="item.isSelected" (change)="check(item)">
                        </label>
                    </div>
                    <div class="content" data-cy="task-details" (click)="selectItemForDetails(item)">
                        <div class="task-team my-1 d-flex justify-content-end">
                            @if(displayTeamNames){
                                <small class="badge rounded-pill text-bg-light">{{item.task.team.name}}</small>
                            }
                        </div>
                        <div class="task-icon pb-3">
                            @switch (item.task.itemType) {
                                @case('moodItem'){
                                    <span class="pe-2">
                                        <img src="{{item.mood.iconPath}}" width="32">
                                    </span>
                                }
                                @case('kudosItem'){
                                    <span class="pe-2">
                                        <i class="fa-light fa-hands-clapping ps-1"></i>
                                    </span>
                                }
                                @case('topicItem'){
                                    <span class="pe-2">
                                        <i class="fa-light fa-messages-question ps-1"></i>
                                    </span>
                                }
                                @default {
                                    @if(item.results){
                                        <span class="pe-2">
                                            <i class="fa-light fa-chart-simple ps-1"></i>
                                        </span>
                                    }
                                }
                            }
                            <span class="ellipsis">{{item.listContent.body}}</span>
                        </div>
                        <div class="d-flex justify-content-between pb-1" [ngClass]="{'pt-1' : item.task.labels.length > 0}">
                            <div class="task-labels">
                                @if(item.task.labels.length > 0){
                                    @for(label of item.task.labels; track label.id){ 
                                        <span class="badge text-bg-light me-1"> <i class="fa-solid fa-circle pe-1" [ngStyle]="{'color': label.color}"></i>{{label.name}}</span> 
                                    }  
                                }
                            </div>
                            
                            <div class="thread-and-reactions">
                                @if(item.task.date){
                                    <small class="task-date" 
                                        [matTooltip]="('backlog.task_details.date' | translate) + ' ' + (item.task.date | date: 'longDate')" matTooltipPosition="above">
                                        {{item.task.date | date_time_from_now }} 
                                    </small>
                                }
                                @if(item.task.threads.length > 0 || item.task.reactions.length > 0){
                                    <small>
                                        <span class="px-1">•</span>
                                        
                                        @if(item.results?.participationRate){
                                            {{'backlog.task_details.participation' | translate}} {{item.results?.participationRate}}
                                        }
                                        @if(item.results?.participationRate && (item.task.threads.length > 0 || item.task.reactions.length > 0)){
                                            <span class="px-1">•</span>
                                        }                       
                                        @if(item.task.reactions.length > 0){  
                                            @let reactions = getTaskReactions(item);
                                            <span matTooltip="{{reactions.allReactionDescription}}">
                                                {{reactions.allReactionHtmlIcons}}&nbsp;{{ reactions.allReactionCount }}
                                            </span>
                                        }
                                        @if(item.task.threads.length > 0 && item.task.reactions.length > 0){
                                            <span class="ps-2"></span>
                                        }
                                        @if(item.task.threads.length > 0){ 
                                            <span matTooltip="{{item.task.threads.length}} {{'backlog.task_details.threads' | translate}}">
                                                <i class="fa-light fa-comments"></i>&nbsp;{{item.task.threads.length}}
                                            </span>
                                        }
                                    </small>
                                }
                            </div>
                        </div>
                    </div> 
                </div>
                
                <div class="task-assignee" (click)="selectItemForDetails(item)">
                   @for(assignee of item.task.assignees; track assignee.id){
                        @if($index < 3){
                            <username-icon context="thread"
                                           [userInfos]="userInfos(assignee)"></username-icon>
                        }
                   }
                   @if(item.task.assignees.length > 3){
                    <small class="ps-1 text-secondary"
                           [matTooltip]="getTooltipAssigneesContent(item.task.assignees)">+{{item.task.assignees.length - 3}}</small>
                }
                </div>              
                <div class="last-update" (click)="selectItemForDetails(item)">
                    @if(item.task.reviews.length > 0){
                        <task-last-update [review]="item.getLastUpdate()"
                                      [userId]="userId"></task-last-update>
                    }
                    <div class="show-on-hover px-lg-3">
                        <button type="button" class="btn btn-default" (click)="archive(item)">
                            <i class="fa-regular fa-archive"></i><span class="archive-label">{{'task_action.archive_after_action' | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>
        }
    }@else{
        <div class="fst-italic text-secondary">
            {{ 'taskbook.backlog.search_empty' | translate}}
            <button class="btn btn-link p-0 fs-6 text-secondary" (click)="clear_search()">{{ 'taskbook.backlog.search_clear' | translate }}</button>.
        </div>
    }  
</div>